<template>
  <div id="OutLineDeal" class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>信用积分</el-breadcrumb-item>
      <el-breadcrumb-item>违规扣分处理</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -20px;" :label-width="formLabelWidth">
        <el-form-item label="举报ID" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入"
            size="small"
            v-model.trim="searchform.reportid"
            :clearable="true"
          ></el-input>
        </el-form-item>

        <el-form-item label="处理结果" :label-width="formLabelWidth">
          <el-select v-model="searchform.result" size="small" clearable>
            <el-option
              v-for="item in elcolData"
              :key="item.value"
              :label="item.key"
              :value="item.value"
              clearable
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="举报时间" :label-width="formLabelWidth" v-show="searchMore">
          <el-date-picker
            size="small"
            v-model="rangeTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="平台" v-show="searchMore">
          <el-select placeholder="请选择" v-model.trim="searchform.platform" size="small" clearable>
            <el-option
              v-for="(item,i) in plateList"
              :key="i+'baaaa'"
              :label="item.dictName"
              :value="item.dictCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称" :label-width="formLabelWidth" v-show="searchMore">
          <el-input placeholder="请输入" v-model="searchform.shopname" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品信息" :label-width="formLabelWidth" v-show="searchMore">
          <el-input placeholder="请输入" v-model="searchform.productname" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="经销商名称" :label-width="formLabelWidth" v-show="searchMore">
          <el-select
            placeholder="请选择"
            v-model="searchform.dealerid"
            autocomplete="on"
            size="small"
            clearable
          >
            <el-option
              v-for="(item,i) in dealData"
              :key="i"
              :label="item.dealername"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-show="searchMore"></el-form-item>
        <el-form-item class="flex_end">
          <el-link
            type="primary"
            :underline="false"
            style="margin-right:20px;"
            @click="searchMore=!searchMore"
          >{{searchMore?'收起查询条件':'更多查询条件'}}</el-link>
          <el-button size="small" @click="searchTable">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <section class="seaerch-wrapper search_more">
      <div class="flex_between">
        <div>
          <el-button size="small" @click="delReduce" type="primary" v-if="type.editStatus">批量扣分</el-button>
          <el-button size="small" @click="downLoad">下载数据</el-button>
        </div>
        <el-radio-group
          v-model="sort"
          size="small"
          @change="sortChange"
        >
          <el-radio-button
            :label="item.value"
            v-for="item in sortList"
            :key="item.value"
          >{{item.name}}</el-radio-button>
        </el-radio-group>
      </div>
      <div v-loading="tableLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" style="min-height:500px">
        <moretable
          :tableData="tableData[index]"
          :tableIndex="index"
          v-for="(item,index) in tableData"
          :key="index"
          @loadPage="sortChange"
          :all='tableData[index].length'
        ></moretable>
        <div v-if="!totalPages" class="no_more_data">暂无更多数据</div>
      </div>

      <el-button class="get_more_btn" @click="clickgetMoreLoad" v-if="totalPages"  :loading="moreLoading"
            element-loading-spinner="el-icon-loading">
        <i class="el-icon-plus el-icon--left"></i>
        加载更多
      </el-button>
    </section>
    <!-- 扣除信用积分 -->
    <el-dialog
      :visible.sync="deductVisible"
      title="批量扣除信用积分"
      width="640px"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="100px"
        :model="deductLine"
        :rules="deductLineRules"
        ref="deductruleForm"
      >
        <el-form-item :required="true" label="扣信用积分" prop="points">
          <el-input
            placeholder="请输入大于0的数值，小数点后一位有效数字"
            v-limitInput
            v-model="deductLine.points"
            clearable
            onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="附加处罚" prop="punish">
          <el-input placeholder="请输入" v-model="deductLine.punish" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="补充说明" prop="pointsexplains">
          <el-input
            placeholder="请输入补充说明，200字以内。"
            clearable
            v-model="deductLine.pointsexplains"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          size="small"
          class="g-confirm-btn"
          @click="deductSubmitForm('deductruleForm')"
          type="confire_btn"
        >确 定</el-button>
        <el-button size="small" class="g-cancel-btn" @click="onClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import checkProduct from "components/checkProduct/index";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost, fetchGetDown } from "@/libs/reqCommon";
import moretable from "./moretable";
import { returnFullTime, getSinceThreeMonth } from "@/libs/date";
export default {
  name: "deal",
  data: function() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      moreLoading:false,
      deductVisible: false,
      //扣分处理
      deductLine: {
        points: "",
        punish: "",
        pointsexplains: ""
      },
      deductLineRules: {
        points: [{ required: true, message: "请输入扣信用积分" }]
      },
      //搜索条件
      searchform: {
        result: "",
        platform: ""
      },
      sort: "r.updatetime desc",
      rangeTime: [],
      formLabelWidth: "100px",
      tableData: [],
      sortList: [
        { name: "按处理时间排序", value: "r.updatetime desc" },
        { name: "按店铺汇总排序", value: "shopname" },
        { name: "按产品汇总排序", value: "productinfo" },
        { name: "按处理结果汇总排序", value: "reason" }
      ],
      chekTableNum: [],
      lastContent: [],
      pagination: {
        pageNo:1,
        pageSize: 0
      },
      elcolData: [],
      searchMore: false,
      totalPages: true,
      productData: [],
      starttime: "",
      endtime: "",
      delInstallList: [
        "店铺在规定时间内整改合格",
        "存在标价违规或到手价违规",
        "存在店铺、平台优惠券或活动违规",
        "存在副标题、广告语、主图违规或咨询客服违规",
        "存在买几送几、买几打几折违规",
        "其他"
      ],
      tableLoading:true,
      dealData: [],
      type: {}
    };
  },
  mounted() {
    this.type = JSON.parse(window.localStorage.userData)
  },
  created() {
    this.getlistOfBmc()
    this.getTime(this.rangeTime);
    this.reqPlateList();
    this.getMoreLoad();
    this.saveCheckId([]);
    this.getReportResult()
    console.log(this.deductMarks)
  },
  computed: {
    ...mapGetters(["plateList"]),
    ...mapState({
      deductMarks: state => state.creditScore.deductMarks
    })
  },
  components: { moretable, checkProduct },
  methods: {
    getlistOfBmc() {
      //初始化
      fetch({
        url: "hcm/dealer/getlistOfBmc",
        method: "get",
      }).then(res => {
        if (res.status == "10000") {
          this.dealData = res.data
        }
      });
    },
    // 信用积分扣分流程手动扣分的各类结果情况
    getReportResult() {
      fetch({
        url: "hcm/hcmReport/getReportResult",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          for(let a in res.data) {
            this.elcolData.push({
              key: res.data[a].key,
              value: res.data[a].value,
              elInput: 0,
            })
          }
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    getRecentDate(picker,n){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.rangeTime[0] = this.$options.filters['fullTime'] (end).substring(0,10);
        this.rangeTime[1] = this.$options.filters['fullTime'] (end).substring(0,10);
      } else {
        this.rangeTime[0] = this.$options.filters['fullTime'] (start).substring(0,10);
        this.rangeTime[1] = this.$options.filters['fullTime'] (end).substring(0,10);
      }
    },
    ...mapActions(["reqPlateList"]),
    ...mapMutations(["saveCheckId"]),
    searchTable() {
      this.getSearchform = this.searchform;
      this.getTime(this.rangeTime);
      this.sortChange();
    },
    getCommonSearch() {
      return {
        ...this.getSearchform,
        ispoint: 0,
        sort: this.sort,
        isMe: "",
        starttime: this.starttime,
        endtime: this.endtime
      };
    },
    //下载
    downLoad() {
      let params = this.getCommonSearch();
      fetchGetDown(
        "hcm/hcmReport/downloadBmcPointsPage",
        params,
        "违规扣分处理"
      );
    },
    deductSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onComfirm();
        } else {
          return false;
        }
      });
    },
    onComfirm() {
      let pointsList = [];
      this.deductMarksResult.forEach(item => {
        if (item) {
          pointsList.push({
            ...this.deductLine,
            reportid: item.reportid
          });
        }
      });
      this.firstInsertPoint(pointsList);
    },
    //第一次扣分处理
    firstInsertPoint(pointsList) {
      fetch({
        method: "POST",
        url: "/hcm/hcmReport/insertPoints",
        data: JSON.stringify(pointsList),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        if (res.status === "10000") {
          this.deductLine = {};
          this.deductVisible = false;
          this.$message.success("成功");
          this.saveCheckId([]);
          this.sortChange(); //刷新列表
        }
      });
    },
    initializeData() {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 50;
      this.tableData = [];
      this.chekTableNum = [];
      this.lastContent = [];
      this.totalPages = true;
    },
    onClose() {
      this.deductVisible = false;
    },
    getListData() {
      let _this=this
      let query = {
        ...this.pagination,
        ...this.getCommonSearch()
      };
      if (this.totalPages) {
        fetchGet("/hcm/hcmReport/getBmcPointsPage", query).then(res => {
          this.tableLoading=false
          this.moreLoading=false
          if (res.status == "10000") {
            this.saveDate(res.data.content);
            this.totalPages =
              res.data.totalPages > this.pagination.pageNo ? true : false;
          }
        });
      }
    },
    saveDate(content) {
      //按照时间排序
      this.lastContent=[]
      let lastContent = this.lastContent; //对比的数组
      let sortName =
        this.sort == "reason"
          ? "result"
          : this.sort == "r.updatetime desc"
          ? "updatetime"
          : this.sort;
      content.forEach((element, index) => {
        let hasSame = false;
        // element.updatetime = returnFullTime(element.updatetime, true);
        lastContent.forEach((item, indexs) => {
          if (sortName === "createtime") {
            //按照时间排序
            let firstTime = new Date(element.createdate);
            let lastTime = new Date(item[0].createdate);
            if (firstTime.getTime() == lastTime.getTime()) {
              hasSame = true;
              item.push(element);
            }
          } else if (sortName === "updatetime") {
            if (element['createdate'] == item[0]['createdate']) {
              hasSame = true;
              item.push(element);
            }
          } else {
            if (element[sortName] == item[0][sortName]) {
              hasSame = true;
              item.push(element);
            }
          }
        });
        if (!hasSame) {
          lastContent[lastContent.length] = [element];
        }
      });
      lastContent.map(item => {
        if (sortName === "updatetime") {
          item[0].checkTitle = item[0]['createdate'];
        } else {
          item[0].checkTitle = item[0][[sortName]];
        }
        item[0].sortName = sortName;
      });
      this.$set(this, "tableData", lastContent);
      this.$forceUpdate();
    },
    clickgetMoreLoad(){
      this.moreLoading=true
      this.getMoreLoad()
    },
    getMoreLoad() {
      this.pagination.pageSize=this.pagination.pageSize+50;
      this.getListData();
    },
    sortChange() {
      this.initializeData();
      this.getListData();
    },
    delReduce() {
      this.deductMarksResult = [].concat.apply([], this.deductMarks);
      if (this.deductMarksResult.length === 0) {
        this.$message.error("没有选中项");
        return false;
      }
      this.deductVisible = true;
    },
    getTime(val) {
      console.log(val)
      if (val.length > 0) {
        this.starttime = val ? this.$options.filters['fullTime'] (val[0]).substring(0,10) : "";
        this.endtime = val ? this.$options.filters['fullTime'] (val[1]).substring(0,10) : "";
      } else {
        this.starttime = val ? val[0] : "";
        this.endtime = val ? val[1] : "";
      }
    }
  }
};
</script>

<style lang="scss" scope="">
@import "src/style/tableCommon";
#OutLineDeal {
  .el-drawer {
    background-color: rgba(240, 242, 245, 1) !important;
  }
  .el-drawer-credit .el-drawer__header {
    background-color: white;
  }
  .search_more {
    min-height: 600px;
  }
  .no-header {
    display: none;
  }
  .get_more_btn {
    width: 410px;
    border: 1px dashed #d9d9d9;
    display: block;
    margin: 20px auto;
  }
  .check_product {
    width: 100%;
  }
}
</style>
